/**
 * Billing page — localization manifest.
 */
export const billingManifest: readonly string[] = [
  "billing.title",
  "billing.plan",
  "billing.upgrade",
  "billing.invoices",
  // Shared
  "nav.billing",
  "common.loading",
  "common.noData",
  "common.amount",
  "common.currency",
  "common.status",
  "common.date",
] as const;
